import React, { Component } from 'react';
import styles from './index.module.scss';
import classnames from 'classnames';
import Footer from 'ui/app/layout/footer';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  selectCurrentUser,
  selectCurrentUserFetchedAtleastOnce,
  selectCurrentUserHasPassword,
  selectIsCurrentUserAdmin,
  selectIsCurrentUserFullAccess,
  selectIsCurrentUserNoAccess,
  selectIsCurrentUserTier3,
  selectIsLoggedIn,
} from '../../../store/features/auth/selectors';
import routeGenerators from '../../common/routes/generators';
import Pathway from './pathway';

const CORE_COMPETENCIES = [
  {
    title: 'Mathematics',
    imgSrc: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/UX.svg',
    listItems: [
      { title: 'Plots' },
      { title: 'Functions and Graphs' },
      { title: 'Matrices and Vectors' },
      { title: 'Statistics' },
      { title: 'Probability' },
      { title: 'Sampling' },
      { title: 'Hypothesis Testing' },
    ],
  },
  {
    title: 'Programming',
    imgSrc: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/Programming-Lean+Six+Sigma.svg',
    listItems: [
      { title: 'Basic Python' },
      { title: 'Data Frameworks' },
      { title: 'Basic Data Engineering' },
      { title: 'Basic Data Science Applications' },
    ],
  },
  {
    title: 'Data Analysis',
    imgSrc:
      'https://indorse-staging-bucket.s3.amazonaws.com/vital/Business+Mindset-Participatory+Design.svg',
    listItems: [
      { title: 'Sense Making of Data and Numbers' },
      { title: 'Critical Thinking For Business' },
      { title: 'Facts, Meaning, Actionable Insights' },
      { title: 'Structuring of Data Insights' },
      { title: 'Compelling Storytelling' },
    ],
  },
  {
    title: 'Data Visualisation',
    imgSrc: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/Communications-Scrum.svg',
    listItems: [
      { title: 'Data Visualisation Types & Components' },
      { title: 'Basic Design Principles' },
      { title: 'Tableau' },
      { title: 'Graphs, Charts & Interactive Visuals' },
      { title: 'Machine Learning Tools' },
    ],
  },
];

class Home extends Component {
  componentDidMount() {
    const { history, loggedIn, currentUser, currentUserFetchedAtleastOnce } = this.props;

    // console.log({ loggedIn, currentUser, currentUserFetchedAtleastOnce });
    const { username } = currentUser || {};
    !!username &&
      loggedIn &&
      currentUserFetchedAtleastOnce &&
      history.push(routeGenerators.users.vanityProfile({ username }));
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { history, loggedIn, currentUser } = this.props;
    if (!!currentUser !== !!nextProps.currentUser && nextProps.currentUserFetchedAtleastOnce) {
      const { username } = currentUser || {};
      !!username &&
        loggedIn &&
        nextProps.currentUserFetchedAtleastOnce &&
        history.push(routeGenerators.users.vanityProfile({ username }));
    }
  }

  render() {
    return (
      <div className={styles.home}>
        <div className={classnames(styles.wrapper)}>
          <div className={classnames(styles.specialContainer)}>
            <div className={classnames(styles.container)}>
              <section className={classnames('d-flex align-items-center', styles.hero)}>
                <div className={classnames(styles.info, 'mx-auto')}>
                  <h1>
                    Your <b>DATA ANALYTICS</b> <br /> Journey Starts Here
                  </h1>
                  <div
                    className={classnames(
                      'd-flex align-items-center justify-content-center',
                      styles.logos
                    )}
                  >
                    <img className="mx-auto" src="/NgeeAnn-Indorse.png" alt="indorse" />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div>
          <div className={classnames(styles.centricityBg)}>
            <div className={classnames('container-fluid mx-auto')}>
              <section className={classnames(styles.coreCompetencies)}>
                <h1 className="text-center">CORE COMPETENCIES</h1>

                <div
                  className={classnames(styles.heroImg, 'd-flex justify-content-center flex-wrap')}
                >
                  {CORE_COMPETENCIES.map((item, idx) => (
                    <div className={classnames(styles.box)} key={idx}>
                      <div>
                        <div className={styles.imgBox}>
                          <img src={item.imgSrc} alt={item.title} />
                        </div>
                        <h3>{item.title}</h3>

                        <ul>
                          {item.listItems.map((lstItm, lstIdx) => {
                            let { sublist } = lstItm;
                            if (sublist && sublist.length) {
                              return (
                                <li key={lstIdx}>
                                  {lstItm.title}
                                  <ul>
                                    {sublist.map((sublst, sublstIdx) => {
                                      return <li key={sublstIdx}>{sublst}</li>;
                                    })}
                                  </ul>
                                </li>
                              );
                            }
                            return <li key={lstIdx}>{lstItm.title}</li>;
                          })}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>
          </div>
        </div>
        <div className={styles.whiteWrapperBg}>
          <div className={classnames(styles.container)}>
            <section className={classnames(styles.centricity)}>
              <h1
                className="text-center"
                style={{
                  color: '#A91932',
                  fontSize: '56px',
                  fontWeight: 'bold',
                  lineHeight: '64px',
                }}
              >
                DATA ANALYTICS Journey
              </h1>
              <h3 className={styles.journeyAssessmentSub}>
                The candidates take the following path in order to go through and complete their
                Data Analytics Journey.
              </h3>
              <div className={classnames(styles.container, 'mt-4')}>
                <div className="mx-5">
                  <Pathway />
                </div>
                <div style={{ marginTop: '10rem' }}>
                  <h1
                    className="text-center"
                    style={{
                      color: '#A91932',
                      fontSize: '56px',
                      fontWeight: 'bold',
                      lineHeight: '64px',
                    }}
                  >
                    Assessment
                  </h1>
                  <h3 className={styles.journeyAssessmentSub}>
                    The skills of every candidate are evaluated on the attributes on 5 point scale
                    in various domains, illustrated using a spider graph.
                  </h3>
                  <div className={'d-flex justify-content-center flex-wrap mt-2'}>
                    <img
                      src={
                        'https://indorse-staging-bucket.s3.amazonaws.com/vital/Spider-Graph1.png'
                      }
                      alt="spidergraph 1"
                      className="my-2 mx-3"
                    />
                    <img
                      src={
                        'https://indorse-staging-bucket.s3.amazonaws.com/vital/Spider-Graph2.png'
                      }
                      alt="spidergraph 2"
                      className="my-2 mx-3"
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isCurrentUserTier3: selectIsCurrentUserTier3(state),
    loggedIn: selectIsLoggedIn(state),
    currentUser: selectCurrentUser(state),
    currentUserFetchedAtleastOnce: selectCurrentUserFetchedAtleastOnce(state),
    currentUserHasPassword: selectCurrentUserHasPassword(state),
    currentUserIsAdmin: selectIsCurrentUserAdmin(state),
    currentUserIsFullAccess: selectIsCurrentUserFullAccess(state),
    currentUserIsNoAccess: selectIsCurrentUserNoAccess(state),
  };
}

export default connect(mapStateToProps, null)(withRouter(Home));



// WEBPACK FOOTER //
// ./src/ui/pages/home/index.js